/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import { qreq } from "../../../shared/qrequest";
import BaseCom from "../../BaseCom";
import Icon from "../../Icon";
import { SidebarGlobal } from "../../_SidebarGlobal";
import { withParamsAndNavigate } from "../../WithParamsAndNavigate";
import L from "../../Lang";

class RuleManagerList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        };
    }

    async componentDidMount() {
        this.applyThemeColors();
        await this.getSettings();
        SidebarGlobal.setSubNav(<>
            <button className="btn btn-primary" onClick={() => this.props.navigate('/rule/new')}><Icon icon="faPlus" /> <span className="d-none d-md-inline"><L>New</L></span></button>
        </>);
        await this.load();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = async () => {
        try {
            let j = await qreq.getAsync('/api/rule/list');
            if (j.list)
                this.setState({ list: j.list });
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    render() {
        return (
            <div className="container-fluid">
                <h1><L>Rule Manager</L></h1>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th style={{ width: '25px' }}></th>
                            <th><L>Rule</L></th>
                            <th><L>Description</L></th>
                            <th><L>Type</L></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.list.map((item, idx) => {
                            return (
                                <tr key={idx}>
                                    <td><Link to={`/rule/${item.id}`}><Icon icon="faPencil" /></Link></td>
                                    <td>{item.name}</td>
                                    <td>{item.description}</td>
                                    <td>{item.priority}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withParamsAndNavigate(RuleManagerList);